import { render, staticRenderFns } from "./RankingShouyou.vue?vue&type=template&id=9fac53a0&scoped=true&"
import script from "./RankingShouyou.vue?vue&type=script&lang=js&"
export * from "./RankingShouyou.vue?vue&type=script&lang=js&"
import style0 from "./RankingShouyou.vue?vue&type=style&index=0&id=9fac53a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fac53a0",
  null
  
)

export default component.exports